import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useT } from "../i18n";
import { supabase } from "../lib/supabase";

export function Login() {
  const { t } = useT();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawNext = searchParams.get("next") || "";
  const next = /^\/app(\/[a-zA-Z0-9_\-\/]*)*$/.test(rawNext) && !rawNext.includes("//") && !rawNext.includes("\\")
    ? rawNext
    : "/app";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    if (!email || !password) return;
    setError(null);
    setSubmitting(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      navigate(next);
    } catch {
      setError(t("loginError"));
    } finally {
      setSubmitting(false);
    }
  }

  async function loginWithGoogle() {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: `${window.location.origin}${next}` },
    });
  }

  return (
    <div className="panel">
      <span className="eyebrow">{t("dashboardEyebrow")}</span>
      <h2>{t("loginTitle")}</h2>

      {error && <div className="banner err">{error}</div>}

      <button className="btn primary" type="button" style={{ marginTop: 16 }} onClick={loginWithGoogle}>
        {t("loginWithGoogle")}
      </button>

      <div className="section-label" style={{ textAlign: "center" }}>
        {t("orDivider")}
      </div>

      <label>
        {t("email")}
        <input value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <label>
        {t("password")}
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>

      <div className="row">
        <button className="btn primary" type="button" disabled={submitting} onClick={() => void submit()}>
          {t("loginSubmit")}
        </button>
      </div>

      <p className="lead" style={{ marginTop: 18 }}>
        {t("noAccount")} <Link to="/signup">{t("signupLink")}</Link>
      </p>
    </div>
  );
}
